var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddNote({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5,
    clipRule: "evenodd",
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "stroke",
    d: "M48.84 23.02V11.6a4.45 4.45 0 00-4.44-4.44H16.28a4.45 4.45 0 00-4.45 4.44v37.9a4.45 4.45 0 004.43 4.44l1.68.01"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "stroke fill",
    d: "M44.6 30.69a18.59 18.59 0 010 37.15 18.59 18.59 0 010-37.15zm-3.29 8h7.27v7.27h7.27v7.27h-7.27v7.27H41.3v-7.26h-7.27v-7.27h7.28v-7.28z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "stroke",
    d: "M21.02 17h18.17m-18.17 6.02h11.14m-11.14 6.24h5.57m-5.57 6.42h1.06"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddNote);
export default __webpack_public_path__ + "static/media/add-note.0ee7d365d9510125e412892240a3fde3.svg";
export { ForwardRef as ReactComponent };